import {isBrowser} from "../../app/utils/read_environment_variables";

/**
 * Fire-and-forget list→detail click counter.
 * Must not block navigation; failures are ignored.
 */
export const trackOfferClick = (offerId: string | number | null | undefined): void => {
    if (!isBrowser || offerId == null || offerId === "") {
        return;
    }

    const id = Number(offerId);
    if (!Number.isFinite(id) || id <= 0) {
        return;
    }

    try {
        void fetch("/api/public/car/click", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({offer_id: id}),
            credentials: "same-origin",
            keepalive: true
        }).catch((err) => {
            console.warn("[offer click] tracking failed", err);
        });
    } catch (err) {
        console.warn("[offer click] tracking failed", err);
    }
};
